exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".textual-animatable {\n  font-size: 40px;\n  position: relative;\n  color: transparent;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n  margin: inherit !important;\n  padding: inherit !important;\n}\n\n.animatable__value {\n  position: absolute;\n  left: 0;\n  top: 0;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n  z-index: 9;\n  margin: inherit !important;\n  padding: inherit !important;\n}\n\n.textual-selectable {\n  position: absolute;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n  cursor: pointer;\n  z-index: 10;\n}\n\n.textual-selectable--selected {\n  border-bottom: 2px solid grey;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/textual/animatable.scss
// module id = 1930
// module chunks = 0